/* eslint-disable */
// @ts-ignore
import('./bootstrap');
